import React from "react";
import { Router, navigate, useLocation } from "@reach/router";
import { useQuery } from "@apollo/client";
import { getViewer } from "types/gql-types";
import { VIEWER_QUERY } from "components/auth/query";
import ContainerWithSidebar from "components/common/layout/ContainerWithSidebar";
import { LoadingSpinner } from "components/graphql-views";
import { Sidebar } from "./components/sidebar";
import { ApplicationCount } from "./components/application-count";
import { ApplicationSource } from "./components/application-source";
import { ApplicationDob } from "./components/application-dob";
import { ApplicationFraud } from "./components/application-fraud";
import { UserStats } from "./components/user-stats";
import { ApplicationStatus } from "./components/application-status";
import { ApplicationRace } from "./components/application-race";
import { ApplicationEthnicity } from "./components/application-ethnicity";
import { ApplicationGender } from "./components/application-gender";

interface Props {
  path: string;
}

export const Reports: React.FC<Props> = () => {
  const { data, error, loading } = useQuery<getViewer>(VIEWER_QUERY);

  if (loading) {
    return (<ContainerWithSidebar>
      <LoadingSpinner/><LoadingSpinner/>
    </ContainerWithSidebar>);
  }
  if (error || !data) return null;
  if (!data.viewer) return null;

  const location = useLocation();
  if (location.pathname.match("/dash/manager/reports[/]?$")) {
    navigate("/dash/manager/reports/applications-received");
  }

  return (
    <ContainerWithSidebar>
      <Sidebar viewer={data.viewer} />
      <Router primary={false}>
        <ApplicationCount path="/applications-received" />
        <ApplicationSource path="/application-source" />
        <ApplicationStatus path="/application-status" />
        <ApplicationDob path="/application-dob" />
        <ApplicationRace path="/application-race" />
        <ApplicationEthnicity path="/application-ethnicity" />
        <ApplicationGender path="/application-gender" />
        {data.viewer.isSupervisor && <ApplicationFraud path="/fraud-detection" />}
        {data.viewer.isSupervisor && <UserStats path="/user-stats" />}
      </Router>
    </ContainerWithSidebar>
  );
};
